import {BackgroundCarouselView} from "./background-carousel.view";
export default BackgroundCarouselView;
